// extracted by mini-css-extract-plugin
export default {"cardGroupsContainer":"JustInSubCategories_cardGroupsContainer__RxgkK"};